import gql from "graphql-tag";

export const SEND_MESSAGE = gql`
  mutation ($input: sendMessageInput) {
    sendMessage(input: $input) {
      _id
      content

      to
      from {
        email
        avatar
      }
      chatId
      created_at
    }
  }
`;
